import { ErrorInfo } from 'ably';
import * as Sentry from '@sentry/react';
import { isAblyTransportError, isTransientAblyError } from './ablyErrors';

export function filterAblyErrorsToSentry(err: ErrorInfo) {
	if (isTransientAblyError(err) || isAblyTransportError(err)) {
		return;
	}

	console.log(err, 'ably error');
	Sentry.captureException(err);
}
